import {Appointment} from './appointment';
import {AppointmentType} from './appointment-type';
import {CalendarAppointment} from './calendar-appointment';
import {PracticePractitioner} from '../../practice-repository/entities/practice-practitioner';

/**
 * Build an Appointment write payload from a CalendarAppointment (read shape)
 * plus optional field overrides. Useful when acting on a calendar-loaded
 * appointment and needing to POST/PUT without refetching the full entity.
 */
export function calendarAppointmentToWriteModel(
  source: CalendarAppointment,
  patch: Partial<Appointment> = {}
): Appointment {
  return {
    id: source.id,
    title: source.title,
    comment: source.comment,
    start: source.start,
    end: source.end,
    practiceId: source.practiceId,
    appointmentType: source.appointmentType as unknown as AppointmentType,
    appointmentMetaData: source.metaData ?? {name: '', cell: '', email: ''},
    patient: undefined,
    patientId: source.patient?.id,
    practiceLocationId: source.location?.id,
    practicePractitionerId: source.practitioner?.id,
    practitioner: source.practitioner as unknown as PracticePractitioner,
    createdDate: source.createdDate,
    lastModifiedDate: source.lastModifiedDate,
    createdUser: source.createdUser,
    lastModifiedUser: source.lastModifiedUser,
    deleted: false,
    ...patch,
  };
}
